import { activationFunctionsComponent } from './activation-functions';
import { alignmentTrainingComponent } from './alignment-training';
import { architectureComparisonComponent } from './architecture-comparison';
import { attentionComponent } from './attention';
import { audioEncoderComponent } from './audio-encoder';
import { attentionSinkComponent } from './attention-sink';
import { backpropagationComponent } from './backpropagation';
import { checkpointRecoveryComponent } from './checkpoint-recovery';
import { chunkedPrefillComponent, disaggregatedPrefillComponent } from './chunked-prefill';
import { clipEncoderComponent } from './clip-encoder';
import { commPrimitivesComponent } from './comm-primitives';
import { configGeneratorComponent } from './config-generator';
import { contrastiveLossComponent } from './contrastive-loss';
import { contextParallelComponent } from './context-parallel';
import { contextExtensionComponent } from './context-extension';
import { cudaTritonKernelsComponent } from './cuda-triton-kernels';
import { continuousBatchingComponent } from './continuous-batching';
import { crossEntropyComponent } from './cross-entropy';
import { dataParallelComponent } from './data-parallel';
import { decodingStrategiesComponent } from './decoding-strategies';
import { diffusionSchedulerComponent } from './diffusion-scheduler';
import { ditArchitectureComponent } from './dit-architecture';
import { distributedDebuggingComponent } from './distributed-debugging';
import { doraComponent } from './dora';
import { dropoutComponent } from './dropout';
import { embeddingComponent } from './embedding';
import { encoderDecoderBlockComponent } from './encoder-decoder-block';
import { evaluationBenchmarkingComponent } from './evaluation-benchmarking';
import { expertParallelComponent } from './expert-parallel';
import { expertParallelDetailComponent } from './expert-parallel-detail';
import { flashAttentionComponent } from './flash-attention';
import { fsdpComponent } from './fsdp';
import { gradientAccumulationComponent } from './gradient-accumulation';
import { gpuMemoryHierarchyComponent } from './gpu-memory-hierarchy';
import { grpoComponent } from './grpo';
import { hybridParallelComponent } from './hybrid-parallel';
import { gradientCheckpointingComponent } from './gradient-checkpointing';
import { graphOptimizationComponent } from './graph-optimization';
import { kvCacheComponent } from './kv-cache';
import { kvCacheCompressionComponent } from './kv-cache-compression';
import { kvCacheQuantizationComponent } from './kv-cache-quantization';
import { imageTokenizerComponent } from './image-tokenizer';
import { inferenceServingComponent } from './inference-serving';
import { knowledgeDistillationComponent } from './knowledge-distillation';
import { loraComponent } from './lora';
import { lookaheadDecodingComponent } from './lookahead-decoding';
import { lrScheduleComponent } from './lr-schedule';
import { mambaComponent } from './mamba';
import { matmulComponent } from './matmul';
import { modelFormatsComponent } from './model-formats';
import { memoryCalculatorComponent } from './memory-calculator';
import { onlineDpoComponent } from './online-dpo';
import { optimizerComponent } from './optimizer';
import { mixedPrecisionComponent } from './mixed-precision';
import { mixtureOfDepthsComponent } from './mixture-of-depths';
import { lmHeadComponent } from './lm-head';
import { mlpComponent } from './mlp';
import { moeRouterComponent } from './moe-router';
import { multiTurnRlhfComponent } from './multi-turn-rlhf';
import { networkTopologyComponent } from './network-topology';
import { normComponent } from './norm';
import { normComparisonComponent } from './norm-comparison';
import { pagedAttentionComponent } from './paged-attention';
import { pipelineParallelComponent } from './pipeline-parallel';
import { ppInterleavedComponent } from './pp-interleaved';
import { positionalEncodingComponent } from './positional-encoding';
import { prefillDecodeComponent } from './prefill-decode';
import { prefixCachingComponent } from './prefix-caching';
import { prefixTuningComponent } from './prefix-tuning';
import { pretrainPipelineComponent } from './pretrain-pipeline';
import { pruningSparsityComponent } from './pruning-sparsity';
import { quantizationComponent } from './quantization';
import { ragArchitectureComponent } from './rag-architecture';
import { residualConnectionComponent } from './residual-connection';
import { rewardModelComponent } from './reward-model';
import { scalingLawsComponent } from './scaling-laws';
import { schedulingComponent } from './scheduling';
import { sequenceParallelComponent } from './sequence-parallel';
import { sftTrainingComponent } from './sft-training';
import { softmaxComponent } from './softmax';
import { syntheticDataPipelineComponent } from './synthetic-data-pipeline';
import { speculativeDecodingComponent } from './speculative-decoding';
import { structuredGenerationComponent } from './structured-generation';
import { tensorParallelComponent } from './tensor-parallel';
import { tokenizerComponent } from './tokenizer';
import { tpOverlapComponent } from './tp-overlap';
import { vitEncoderComponent } from './vit-encoder';
import { vlFusionComponent } from './vl-fusion';
import { trainingPerformanceComponent } from './training-performance';
import { moeLayerComponent } from './moe-layer';
import { transformerBlockComponent } from './transformer-block';
import { weightInitComponent } from './weight-init';
import { zeroStage3Component } from './zero-stage3';
import { ComponentCategory, ComponentDef } from './types';

const registry = new Map<string, ComponentDef>([
  [embeddingComponent.id, embeddingComponent],
  [positionalEncodingComponent.id, positionalEncodingComponent],
  [attentionComponent.id, attentionComponent],
  [normComponent.id, normComponent],
  [residualConnectionComponent.id, residualConnectionComponent],
  [mlpComponent.id, mlpComponent],
  [moeRouterComponent.id, moeRouterComponent],
  [moeLayerComponent.id, moeLayerComponent],
  [mixtureOfDepthsComponent.id, mixtureOfDepthsComponent],
  [lmHeadComponent.id, lmHeadComponent],
  [transformerBlockComponent.id, transformerBlockComponent],
  [encoderDecoderBlockComponent.id, encoderDecoderBlockComponent],
  [mambaComponent.id, mambaComponent],
  [ragArchitectureComponent.id, ragArchitectureComponent],
  [architectureComparisonComponent.id, architectureComparisonComponent],
  [matmulComponent.id, matmulComponent],
  [softmaxComponent.id, softmaxComponent],
  [dropoutComponent.id, dropoutComponent],
  [activationFunctionsComponent.id, activationFunctionsComponent],
  [normComparisonComponent.id, normComparisonComponent],
  [tokenizerComponent.id, tokenizerComponent],
  [backpropagationComponent.id, backpropagationComponent],
  [weightInitComponent.id, weightInitComponent],
  [crossEntropyComponent.id, crossEntropyComponent],
  [contrastiveLossComponent.id, contrastiveLossComponent],
  [decodingStrategiesComponent.id, decodingStrategiesComponent],
  [flashAttentionComponent.id, flashAttentionComponent],
  [kvCacheComponent.id, kvCacheComponent],
  [pagedAttentionComponent.id, pagedAttentionComponent],
  [quantizationComponent.id, quantizationComponent],
  [continuousBatchingComponent.id, continuousBatchingComponent],
  [speculativeDecodingComponent.id, speculativeDecodingComponent],
  [memoryCalculatorComponent.id, memoryCalculatorComponent],
  [gradientCheckpointingComponent.id, gradientCheckpointingComponent],
  [mixedPrecisionComponent.id, mixedPrecisionComponent],
  [trainingPerformanceComponent.id, trainingPerformanceComponent],
  [configGeneratorComponent.id, configGeneratorComponent],
  [graphOptimizationComponent.id, graphOptimizationComponent],
  [pruningSparsityComponent.id, pruningSparsityComponent],
  [contextExtensionComponent.id, contextExtensionComponent],
  [attentionSinkComponent.id, attentionSinkComponent],
  [prefillDecodeComponent.id, prefillDecodeComponent],
  [gpuMemoryHierarchyComponent.id, gpuMemoryHierarchyComponent],
  [inferenceServingComponent.id, inferenceServingComponent],
  [schedulingComponent.id, schedulingComponent],
  [evaluationBenchmarkingComponent.id, evaluationBenchmarkingComponent],
  [structuredGenerationComponent.id, structuredGenerationComponent],
  [cudaTritonKernelsComponent.id, cudaTritonKernelsComponent],
  [modelFormatsComponent.id, modelFormatsComponent],
  [pretrainPipelineComponent.id, pretrainPipelineComponent],
  [sftTrainingComponent.id, sftTrainingComponent],
  [alignmentTrainingComponent.id, alignmentTrainingComponent],
  [loraComponent.id, loraComponent],
  [rewardModelComponent.id, rewardModelComponent],
  [optimizerComponent.id, optimizerComponent],
  [knowledgeDistillationComponent.id, knowledgeDistillationComponent],
  [lrScheduleComponent.id, lrScheduleComponent],
  [scalingLawsComponent.id, scalingLawsComponent],
  [checkpointRecoveryComponent.id, checkpointRecoveryComponent],
  [gradientAccumulationComponent.id, gradientAccumulationComponent],
  [dataParallelComponent.id, dataParallelComponent],
  [tensorParallelComponent.id, tensorParallelComponent],
  [pipelineParallelComponent.id, pipelineParallelComponent],
  [fsdpComponent.id, fsdpComponent],
  [expertParallelDetailComponent.id, expertParallelDetailComponent],
  [contextParallelComponent.id, contextParallelComponent],
  [sequenceParallelComponent.id, sequenceParallelComponent],
  [hybridParallelComponent.id, hybridParallelComponent],
  [commPrimitivesComponent.id, commPrimitivesComponent],
  [networkTopologyComponent.id, networkTopologyComponent],
  [distributedDebuggingComponent.id, distributedDebuggingComponent],
  [audioEncoderComponent.id, audioEncoderComponent],
  [vitEncoderComponent.id, vitEncoderComponent],
  [clipEncoderComponent.id, clipEncoderComponent],
  [imageTokenizerComponent.id, imageTokenizerComponent],
  [vlFusionComponent.id, vlFusionComponent],
  [ditArchitectureComponent.id, ditArchitectureComponent],
  [lookaheadDecodingComponent.id, lookaheadDecodingComponent],
  [diffusionSchedulerComponent.id, diffusionSchedulerComponent],
  [grpoComponent.id, grpoComponent],
  [onlineDpoComponent.id, onlineDpoComponent],
  [multiTurnRlhfComponent.id, multiTurnRlhfComponent],
  [syntheticDataPipelineComponent.id, syntheticDataPipelineComponent],
  [tpOverlapComponent.id, tpOverlapComponent],
  [ppInterleavedComponent.id, ppInterleavedComponent],
  [zeroStage3Component.id, zeroStage3Component],
  [expertParallelComponent.id, expertParallelComponent],
  [chunkedPrefillComponent.id, chunkedPrefillComponent],
  [disaggregatedPrefillComponent.id, disaggregatedPrefillComponent],
  [prefixCachingComponent.id, prefixCachingComponent],
  [prefixTuningComponent.id, prefixTuningComponent],
  [doraComponent.id, doraComponent],
  [kvCacheCompressionComponent.id, kvCacheCompressionComponent],
  [kvCacheQuantizationComponent.id, kvCacheQuantizationComponent]
]);

export function getComponent(id: string): ComponentDef | undefined {
  return registry.get(id);
}

export function getAllComponents(): ComponentDef[] {
  return Array.from(registry.values());
}

export function getComponentsByCategory(category: ComponentCategory): ComponentDef[] {
  return getAllComponents().filter((c) => c.category === category);
}
